module.exports = __webpack_public_path__ + "static/furniture-banner-sale-section-c499c0e2e16c799155eaa2612c1e9971.png";